import { render, staticRenderFns } from "./AddCustomerRecord.vue?vue&type=template&id=4ad857d9&"
import script from "./AddCustomerRecord.vue?vue&type=script&lang=js&"
export * from "./AddCustomerRecord.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports